import React from "react";
import classes from "./ToggleSwitchInput.scss";
import classNames from "classnames";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import { ToggleSwitch } from "@toddle-edu/ds-web";

class SwitchButton extends UIBaseComponent {
  renderEdit = () => {
    const {
      value,
      isDisabled,
      toggleLabel,
      toggleSubText,
      toggleLabelStyle,
      toggleSubTextStyle,
      displayDisabledAsActive = false,
      testId,
    } = this.props;

    /*******************************************************************************************************
     * displayDisabledAsActive flag is used to control the visual state of this component,
     * where if it is true, we will show the element in visually active form but
     * functionality wise it will behave like disabled
     ********************************************************************************************************/

    const showDisabledActiveState = isDisabled && displayDisabledAsActive;
    const toggleSwitchContainerClass = classNames({
      [classes.displayDisabledAsActive]: showDisabledActiveState,
    });

    const handleToggleChange = event => {
      if (showDisabledActiveState) return;
      this.updateValue(event.target.checked);
    };

    return (
      <div className={classes.container}>
        {(toggleLabel || toggleSubText) && (
          <div className={classes.textContainer}>
            {toggleLabel && (
              <div className="text-body" style={toggleLabelStyle}>
                {toggleLabel}
              </div>
            )}
            {toggleSubText && (
              <div
                className="text-body-s text-secondary"
                style={toggleSubTextStyle}
              >
                {toggleSubText}
              </div>
            )}
          </div>
        )}
        <div className={toggleSwitchContainerClass}>
          <ToggleSwitch
            onChange={handleToggleChange}
            disabled={isDisabled && !displayDisabledAsActive}
            checked={value}
            testId={testId}
            dsVersion="2.0"
          />
        </div>
      </div>
    );
  };
}

SwitchButton.defaultProps = {
  ...UIBaseComponent.defaultProps,
};

export default SwitchButton;
